import type { Task, Priority } from '@/types';

export interface InboxFilterState {
  priority: Priority | 'all';
  tag: string | null;
}

export function countInboxTasks(tasks: Task[]): number {
  let n = 0;
  for (const t of tasks) if (t.status === 'inbox') n++;
  return n;
}

export function tagsInInbox(tasks: Task[]): string[] {
  const set = new Set<string>();
  for (const t of tasks) {
    if (t.status !== 'inbox') continue;
    for (const tag of t.tags) set.add(tag);
  }
  return [...set].sort();
}

export function filterInboxTasks(tasks: Task[], filters: InboxFilterState): Task[] {
  return tasks
    .filter((t) => t.status === 'inbox')
    .filter((t) => filters.priority === 'all' || t.priority === filters.priority)
    .filter((t) => filters.tag === null || t.tags.includes(filters.tag))
    .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());
}
